import Link from 'next/link';
import { FC, JSX } from 'react';

import usePublicTranslation from '@/hooks/usePublicTranslation';
import useReadingTimeCalculator from '@/hooks/useReadingTimeCalculator';
import { formatUnixTimestamp } from '@/utils/date';

const contentExcerptLength = 180;

const getExcerptWithoutHtml = (html: string, length: number) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';
  if (text.length <= length) {
    return text;
  }
  return text.substring(0, length) + '...';
};

export const NAME = 'image-left';

type Props = {
  image?: string | null;
  title: string;
  alias: string;
  date: number;
  content: string;
  titleTag?: string;
};

const ImageLeftTemplate: FC<Props> = ({ image, title, alias, date, content, titleTag = 'h2' }) => {
  const TitleTag = titleTag as keyof JSX.IntrinsicElements;
  const t = usePublicTranslation();
  const { readingTime } = useReadingTimeCalculator({ content });

  return (
    <div className="wp-block wp-block-media-text wp-image-left-template is-stacked-on-mobile">
      <figure className="wp-block-media-text__media image-left-template-image">
        {
          // eslint-disable-next-line @next/next/no-img-element
          image && <img src={image} alt="" />
        }
      </figure>
      <div className="wp-block-media-text__content image-left-template-content">
        <TitleTag>
          <Link href={alias}>{title}</Link>
        </TitleTag>
        <div className="image-left-template-excerpt">
          <p dangerouslySetInnerHTML={{ __html: getExcerptWithoutHtml(content, contentExcerptLength) }} />
          <Link href={alias} className="image-left-template-read-more-button">
            {t('page.read_more')}
          </Link>
        </div>
        <div className="image-left-template-meta">
          <span className="image-left-template-date">{formatUnixTimestamp(date, 'MMMM DD, YYYY')}</span>
          <span className="image-left-template-meta-separator">/</span>
          <span className="image-left-template-reading-time">
            {t('page.reading_time', { time: readingTime || '' })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ImageLeftTemplate;
